import React, { FC } from 'react';
import { Avatar } from 'components/atoms/avatar';
import { CompanyAsResource } from 'components/organisms/resource-management/resource-types';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import { CellWrapper, TextWrapperWithEllipsis } from './component';

interface Props
  extends Pick<
    CompanyAsResource,
    'companyId' | 'companyName' | 'companyLogoUrl'
  > {
  onWrapperClick: () => void;
}
export const CompanyCellForUsersView: FC<Props> = ({
  companyName,
  companyLogoUrl,
  onWrapperClick,
}) => {
  return (
    <CellWrapper onClick={onWrapperClick}>
      <NameCell
        logo={<Avatar src={companyLogoUrl} name={companyName} />}
        primaryText={
          <TextWrapperWithEllipsis data-cy={companyName}>
            {companyName}
          </TextWrapperWithEllipsis>
        }
      />
    </CellWrapper>
  );
};
